import { Link } from "react-router-dom";
import logo from "@/assets/logo.svg";

export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="mx-auto max-w-7xl flex items-center justify-between px-6 py-4">
        <Link
          to="/"
          className="flex items-center"
        >
          <img src={logo} alt="MedXPro Health" className="h-14 w-auto object-contain" />
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-foreground">
          {/* <Link to="/about" className="hover:text-primary">
            About
          </Link>
          <Link to="/services" className="hover:text-primary">
            Services
          </Link>
          <Link to="/contact" className="hover:text-primary">
            Contact
          </Link> */}
          {/* <Link
            to="/login"
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Login
          </Link> */}
        </nav>
      </div>
    </header>
  );
}
